import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';


import { AppComponent } from './app.component';

// Providers
import { ServiceWorkerModule } from '@angular/service-worker';

import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing.module';
import { environment } from '@environments/environment';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { CommonPageComponentsModule } from '../common-page-components/common-page-components.module';
@NgModule({
  declarations: [AppComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    RouterModule,
    AppRoutingModule,
    CommonPageComponentsModule,
    FormsModule,
    ServiceWorkerModule.register('/sites/all/modules/custom/wa_angular/includes/plugins/content_types/main/ngsw-worker.js', {
      enabled: environment.production
    })
  ],
  bootstrap: []
})
export class AppModule {
  constructor(http: HttpClient) {
    if (environment.production === true) {
      console.log = (data) => {

      }
    }
  }
}
